import { render } from "./TemplatesShowcaseV2.vue?vue&type=template&id=35bb0736"
import script from "./TemplatesShowcaseV2.vue?vue&type=script&lang=js"
export * from "./TemplatesShowcaseV2.vue?vue&type=script&lang=js"

import "./TemplatesShowcaseV2.vue?vue&type=style&index=0&id=35bb0736&lang=css"
import "./TemplatesShowcaseV2.vue?vue&type=style&index=1&id=35bb0736&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-showcase/leadsbroker-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__